import React from 'react';
import useMountedState from '../hooks/useMountedState';
import useTimeout from '../hooks/useTimeout';
import CircularProgress, {CircularProgressProps} from './CircularProgress';

interface LoaderProps extends CircularProgressProps {
  delay?: number;
}

export default function Loader({delay = 200, ...props}: LoaderProps) {
  const isMounted = useMountedState();
  const [visible, setVisible] = React.useState<boolean>(false);

  useTimeout(() => {
    if (!isMounted()) {
      return;
    }
    setVisible(true);
  }, delay);

  return visible || !delay ? (<CircularProgress {...props} />) : null;
}